import { commonMacro } from './common-macro';
export var anchorMacro = function anchorMacro(_ref) {
  var input = _ref.input,
    position = _ref.position,
    schema = _ref.schema,
    context = _ref.context;
  return commonMacro(input.substring(position), schema, {
    keyword: 'anchor',
    paired: false,
    context: context,
    rawContentProcessor: rawContentProcessor
  });
};
var rawContentProcessor = function rawContentProcessor(_rawAttrs, _rawContent, length, _schema, _context) {
  return {
    type: 'text',
    text: '',
    length: length
  };
};